export default __webpack_public_path__ + "static/media/Ellipse 25.e4bca772.svg";